
import api from '@/api';

const namespaced = true;

const state = {
};

const mutations = {
};

const actions = {
  async fetchList(store, { queryParams = {} }) {
    const { data: challengingInterventions } = await api.get(`/challenging-interventions`, {
      params: queryParams,
    });

    return challengingInterventions;
  },
  async fetchOne(store, id) {
    const { data: challengingIntervention } = await api.get(`/challenging-interventions/${id}`);

    return challengingIntervention;
  },
};

const getters = {
};

export default {
  namespaced, state, mutations, actions, getters,
};
